import { render, staticRenderFns } from "./AccountStatement.vue?vue&type=template&id=f00dc54a&scoped=true"
import script from "./AccountStatement.vue?vue&type=script&lang=js"
export * from "./AccountStatement.vue?vue&type=script&lang=js"
import style0 from "./AccountStatement.vue?vue&type=style&index=0&id=f00dc54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00dc54a",
  null
  
)

export default component.exports